(function () {
  var root = document.querySelector("[data-tl-track]");
  if (!root) return;

  var input = root.querySelector("[data-tl-track-input]");
  var form = root.querySelector("[data-tl-track-form]");
  var err = root.querySelector("[data-tl-track-err]");
  var widget = root.querySelector("[data-tl-track-widget]");
  var codeEl = root.querySelector("[data-tl-track-code]");
  var lang = (root.getAttribute("data-lang") || "nl").indexOf("en") === 0 ? "en" : "nl";
  var scriptSrc = "https://www.17track.net/externalcall.js";
  var loaded = false;

  function showErr(on) {
    if (!err) return;
    err.classList.toggle("is-on", !!on);
  }

  function readQueryNum() {
    var q = new URLSearchParams(window.location.search);
    return (q.get("n") || q.get("nums") || q.get("tracking") || "").trim();
  }

  function cleanNum(raw) {
    return String(raw || "")
      .replace(/^\s+|\s+$/g, "")
      .replace(/\s+/g, "")
      .slice(0, 50);
  }

  function loadWidgetLib() {
    if (loaded && window.YQV5) return Promise.resolve();
    if (window.YQV5) {
      loaded = true;
      return Promise.resolve();
    }
    return new Promise(function (resolve, reject) {
      var s = document.createElement("script");
      s.src = scriptSrc;
      s.async = true;
      s.onload = function () {
        loaded = true;
        resolve();
      };
      s.onerror = function () {
        reject(new Error("widget"));
      };
      document.body.appendChild(s);
    });
  }

  function track(num) {
    var n = cleanNum(num);
    if (!n) {
      showErr(true);
      return;
    }
    showErr(false);
    if (input) input.value = n;
    if (codeEl) codeEl.textContent = n;
    loadWidgetLib()
      .then(function () {
        if (!window.YQV5 || typeof window.YQV5.trackSingle !== "function") {
          throw new Error("widget");
        }
        window.YQV5.trackSingle({
          YQ_ContainerId: widget.id,
          YQ_Height: 560,
          YQ_Fc: "0",
          YQ_Lang: lang,
          YQ_Num: n,
        });
      })
      .catch(function () {
        showErr(true);
      });
  }

  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var n = cleanNum(input && input.value);
      if (!n) {
        showErr(true);
        return;
      }
      var url = new URL(window.location.href);
      url.searchParams.set("n", n);
      history.replaceState({}, "", url.toString());
      track(n);
    });
  }

  var initial = readQueryNum();
  if (initial) track(initial);
})();
